export default __webpack_public_path__ + "static/media/RTR 160 4V_5.18591089.webp";